import type { DatePickerProps } from 'antd';
import { DatePicker as AntDatePicker } from 'antd';
import type { RangePickerProps } from 'antd/es/date-picker';

import { DATE_FORMAT } from '@/constants';

export const DatePicker = (props: DatePickerProps) => {
  return <AntDatePicker format={DATE_FORMAT} {...props} />;
};

export const RangePicker = (props: RangePickerProps) => {
  return <AntDatePicker.RangePicker format={DATE_FORMAT} {...props} />;
};

export default DatePicker;
